import { Tabs } from "@/components/ui/overlay/Tabs";
import { OrgPermissionsTab } from "../components/security/OrgPermissionsTab";
import { SecurityInvariantsTab } from "../components/security/SecurityInvariantsTab";

/**
 * SECURITY-PAGE-TRUTH-1 (TR-2026-10-16-8 A1, A5): no Security Settings tab (no
 * backend reads or stores its controls). "Always enforced" lists rules a
 * required CI job proves.
 *
 * WS-CEILINGS-TAB-OFF-1 (TR-2026-10-20-1 item 4): no Workspace Permissions tab.
 * Its owner ceilings are being retired for fixed rules (FR-2026-10-16-2/-3), so
 * the screen no longer offers them. The component stays on disk for W1-6.
 */
export default function AdministrationSecurityPage() {
  const tabItems = [
    { id: "org-permissions", label: "Org Permissions", content: <OrgPermissionsTab /> },
    { id: "always-enforced", label: "Always enforced", content: <SecurityInvariantsTab /> },
  ];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl font-bold text-gray-900">Security</h1>
        <p className="text-sm text-gray-500 mt-1">
          Manage role permissions and see what is always enforced.
        </p>
      </div>
      <Tabs items={tabItems} defaultActiveTab="org-permissions" />
    </div>
  );
}
